import { render, staticRenderFns } from "./DteStandardDetailSection.vue?vue&type=template&id=3bc6de14"
import script from "./DteStandardDetailSection.vue?vue&type=script&lang=js"
export * from "./DteStandardDetailSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports